<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="tree-menu">
    <div v-for="op in tutorialsData" :key="op.name">
      <span class="folder-name">{{ op.name }}</span>
      <div 
        v-for="v in op.options"
        :key="v.title"
        class="op-wrap"
        :class="selectedTuto.folder === op.name && selectedTuto.option === v.name && 'selected'"
      >
        <span class="option-wrapper" @click="changeTutoSel(op.name, v.name)">{{ v.title }}</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  components: {  },
  directives: {  },
  props: {
    tutorialsData: {
      type: Array
    },
    selectedTuto: {
      type: Object,
    },
  },
  asyncComputed: {},
  methods: {
    changeTutoSel(fol, op) {
      let tuto = {
        folder: fol,
        option: op,
      }
      this.$emit('change-default-tuto', tuto)
    }
  },
}
</script>

<style lang="stylus" scoped>
.tree-menu
  position: sticky
  top: "calc(%s + %s + %s)" % ($header-height $subheader-height vw(10px))
  height: min-content
  display: flex
  flex-direction: column
  min-width: vw(300px)
  gap: vw(15px)
  padding: vw(30px) vw(25px) vw(40px)
  background-color: #fff
  box-shadow: 0 0 10px rgba(#000, 0.05)

  .mobile &
    width: 100%
    position: relative
    top: 0

  .folder-name
    m-font-size(18, 26)
    font-weight: 600
    color: black

  .op-wrap
    margin-top: vw(10px)
    display: flex
    flex-direction: column
    gap: vw(10px)
    margin-left: vw(10px)
    width: fit-content
    border-bottom: 2px solid transparent

    .option-wrapper
      m-font-size(16, 24)
      font-weight: 400
      color: $grey-dark
      cursor: pointer
      padding: 0 vw(5px)

    &.selected
      border-bottom: 2px solid $corporate_color

      .option-wrapper
        color: $corporate_color

    &:hover
      border-bottom: 2px solid black

      .option-wrapper
        color: black
</style>
